
import { inject, Injectable } from "@angular/core";
import { CommonProcessTreeQueryComplexInput, CommonProcessTreeSortInput, ComparatorOperators, CptCatalogueSimpleQueryInput, CptCatalogueSortInput, CptCatalogueV2Columns, CptQueryComplexGQL, CptQueryComplexInput, CptQueryComplexQuery, CptQuerySimpleInput, ExportCptGQL, ExportCptMutation, GetCptTreeGQL, GetCptTreeQuery, OperatorInput, OrderTypeInput, PagingInput, SyncronizeCptsGQL, SyncronizeCptsMutation } from "../../../graphql/generated";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class CptService {
    private readonly CptQueryComplexGQL: CptQueryComplexGQL = inject(CptQueryComplexGQL);
    // private readonly CptQuerySearchGQL: CptQuerySearchGQL = inject(CptQuerySearchGQL);
    private readonly ExportCptGQL: ExportCptGQL = inject(ExportCptGQL);
    private readonly GetCptTreeGQL: GetCptTreeGQL = inject(GetCptTreeGQL);
    private readonly SyncronizeCptsGQL: SyncronizeCptsGQL = inject(SyncronizeCptsGQL);


    getCpts(parameters: any): Observable<CptQueryComplexQuery['cptCatalogueByQueryComplex']> {
        const param = convertLazyLoadToComplexWithoutPageCpt(parameters);
        return this.CptQueryComplexGQL.fetch({ query: param.query as CptQueryComplexInput, sort: param.sort as CptCatalogueSortInput, page: param.page as PagingInput }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.cptCatalogueByQueryComplex));
    }

    getCptsTree(parameters: any): Observable<GetCptTreeQuery['commonProcessTree']> {
        const param = convertLazyLoadToComplexWithoutPageCptTree(parameters);
        return this.GetCptTreeGQL.fetch({ query: param.query as CommonProcessTreeQueryComplexInput, sort: param.sort as CommonProcessTreeSortInput }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.commonProcessTree));
    }

    // getCptsSearch(parameters: any, search?: string): Observable<CptQuerySearchQuery['cptCatalogueFreeTextQuery']> {
    //     const param = convertLazyLoadToComplexWithoutPageCpt(parameters);
    //     return this.CptQuerySearchGQL.fetch({ query: param.query as CptQueryComplexInput, sort: param.sort as CptCatalogueSortInput, page: param.page as PagingInput, search: search ? search : '' }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data.cptCatalogueFreeTextQuery));
    // }

    exportCpts(parameters: any, timeZone: string): Observable<ExportCptMutation['downloadCommonProcessTreeByQuery']> {
        const param = convertLazyLoadToComplexWithoutPageCptTree(parameters);
        return this.ExportCptGQL.mutate({ query: param.query as CommonProcessTreeQueryComplexInput, sort: param.sort as CommonProcessTreeSortInput, timeZone }, { fetchPolicy: 'no-cache' }).pipe(map(result => result.data?.downloadCommonProcessTreeByQuery));
    }

    syncronizeCpt(): Observable<SyncronizeCptsMutation['batchExecutionCptCatalogue']> {
        return this.SyncronizeCptsGQL.mutate().pipe(map(res => res.data?.batchExecutionCptCatalogue))
    }
}

export function convertLazyLoadToComplexWithoutPageCpt(parameters: any): { query: CptQueryComplexInput, sort: CptCatalogueSortInput, page: PagingInput } {
    const query: { [key: string]: CptCatalogueSimpleQueryInput[] } = {};
    const querySearch: CptCatalogueSimpleQueryInput[] = [];
    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_CPT[field as keyof typeof ENUM_CPT] || [field]).forEach(key => {
                        query[field] ??= [];
                        query[field].push({
                            field: key as CptCatalogueV2Columns,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: values
                            }
                        });
                    })
                }
            });
        }
    }

    const querySend: CptQuerySimpleInput[] = [];
    Object.keys(query).forEach(key => {
        querySend.push({
            operator: OperatorInput.And,
            query: query[key]
        })
    })

    if (parameters?.search && parameters.search !== '') {
        Object.keys(ENUM_CPT).forEach(key => {
            if (key !== 'orderId') {
                (ENUM_CPT[key as keyof typeof ENUM_CPT] || [key]).forEach(key => {
                    querySearch.push({
                        field: key as CptCatalogueV2Columns,
                        filters: {
                            operator: ComparatorOperators.Contains,
                            value: parameters.search
                        }
                    });
                });
            }
        })
        querySend.push({
            operator: OperatorInput.And,
            query: querySearch
        })
    }


    return {
        query: {
            operator: OperatorInput.And,
            query: querySend
        },
        sort: {
            sortField: ENUM_CPT?.[parameters?.order?.sortField as keyof typeof ENUM_CPT]?.[0] as CptCatalogueV2Columns || 'LEVEL_ONE_ID_FOR_SORTING',
            sortOrder: parameters?.order?.sortDirection === 'ASC' ? OrderTypeInput.Asc : OrderTypeInput.Desc
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 10000
        }
    }
}

export function convertLazyLoadToComplexWithoutPageCptTree(parameters: any): { query: CptQueryComplexInput, sort: CptCatalogueSortInput, page: PagingInput } {
    const query: { [key: string]: CptCatalogueSimpleQueryInput[] } = {};
    const querySearch: CptCatalogueSimpleQueryInput[] = [];
    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_CPT_TREE[field as keyof typeof ENUM_CPT_TREE] || [field]).forEach(key => {
                        query[field] ??= [];
                        query[field].push({
                            field: key as CptCatalogueV2Columns,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: values
                            }
                        });
                    })
                }
            });
        }
    }

    const querySend: CptQuerySimpleInput[] = [];
    Object.keys(query).forEach(key => {
        querySend.push({
            operator: OperatorInput.Or,
            query: query[key]
        })
    })

    if (parameters?.search && parameters.search !== '') {
        Object.keys(ENUM_CPT_TREE).forEach(key => {
            if (key !== 'orderId') {
                (ENUM_CPT_TREE[key as keyof typeof ENUM_CPT_TREE] || [key]).forEach(key => {
                    querySearch.push({
                        field: key as CptCatalogueV2Columns,
                        filters: {
                            operator: ComparatorOperators.Contains,
                            value: parameters.search
                        }
                    });
                });
            }
        })
        querySend.push({
            operator: OperatorInput.Or,
            query: querySearch
        })
    }


    return {
        query: {
            operator: OperatorInput.And,
            query: querySend
        },
        sort: {
            sortField: ENUM_CPT_TREE?.[parameters?.order?.sortField as keyof typeof ENUM_CPT_TREE]?.[0] as CptCatalogueV2Columns ?? ENUM_CPT_TREE.orderId[0],
            sortOrder: parameters?.order?.sortDirection === 'ASC' ? OrderTypeInput.Asc : OrderTypeInput.Desc
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 10000
        }
    }
}

export const ENUM_CPT = {
    cluster: ['LEVEL_ONE_CLUSTER', 'LEVEL_TWO_CLUSTER', 'LEVEL_THREE_CLUSTER'],
    internalAuditDomain: ['LEVEL_ONE_INTERNAL_AUDIT_DOMAIN', 'LEVEL_TWO_INTERNAL_AUDIT_DOMAIN', 'LEVEL_THREE_INTERNAL_AUDIT_DOMAIN'],
    code: ['LEVEL_ONE_PROCESS_CODE', 'LEVEL_TWO_PROCESS_CODE', 'LEVEL_THREE_PROCESS_CODE'],
    name: ['LEVEL_ONE_PROCESS_NAME', 'LEVEL_TWO_PROCESS_NAME', 'LEVEL_THREE_PROCESS_NAME'],
    processStatus: ['LEVEL_ONE_PROCESS_STATUS', 'LEVEL_TWO_PROCESS_STATUS', 'LEVEL_THREE_PROCESS_STATUS'],
    valueChain: ['LEVEL_ONE_VALUE_CHAIN', 'LEVEL_TWO_VALUE_CHAIN', 'LEVEL_THREE_VALUE_CHAIN'],
    orderId: ["LEVEL_ONE_ID_FOR_SORTING"],
    valueChainBackup: ["LEVEL_ONE_VALUE_CHAIN"],
    auditArea: ["AUDIT_AREA"],
    auditSubdomain: ["AUDIT_SUB_AREA"],
    auditSubArea: ["AUDIT_SUB_AREA"],
    auditDomain: ["AUDIT_AREA"]
}

export const ENUM_CPT_TREE = {
    cluster: ['CLUSTER'],
    internalAuditDomain: ['INTERNAL_AUDIT_DOMAIN'],
    code: ['CODE'],
    name: ['NAME'],
    processStatus: ['STATUS'],
    valueChain: ['VALUE_CHAIN'],
    orderId: ["SORT"],
    auditSubdomain: ["AUDIT_SUBDOMAIN"],
    auditDomain: ["AUDIT_DOMAIN"],
    status: ['STATUS'],
    auditArea: ["AUDIT_DOMAIN"],
    auditSubArea: ["AUDIT_SUBDOMAIN"],
    sort: ['SORT']
}